import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  useDeveloperSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import {
  IEditDeveloperSettings,
  IViewDeveloperSettings,
} from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { devSettingsValidationSchema } from "./validationSchema";

import { View } from "./View";
import { useApiKeys } from "../../hooks/useApiKeys";

export const Developers = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingDeveloperSettings,
    isSuccess: isSuccessDeveloperSettings,
    data: developerSettings,
    refreshRemoteData: refreshDeveloperSettings,
  } = useDeveloperSettings();

  const {
    // isLoading: isLoadingApiKeys,
    isSuccess: isSuccessApiKeys,
    data: apiKeys,
    refreshRemoteData: refreshApiKeys,
  } = useApiKeys();

  // useEffect(() => {
  //   developerSettings && reset(developerSettings);
  // }, []);

  useEffect(() => {
    if (isSuccessDeveloperSettings) {
      developerSettings && reset(developerSettings);
    }
  }, [isSuccessDeveloperSettings]);

  const initialFormValues: IEditDeveloperSettings = {
    // webhooks
    live_webhook_url: null,
    test_webhook_url: null,

    // redirects
    live_redirect_url: null,
    test_redirect_url: null,
  };

  const { isSuccess: isSuccessClearApiKeys, mutate: clearApiKeys } =
    useMerchantApiMutation<void, IViewDeveloperSettings>(
      "clearApiKeys"
    ).usePostMutation;

  useEffect(() => {
    if (isSuccessClearApiKeys) {
      refreshApiKeys();
    }
  }, [isSuccessClearApiKeys]);

  const { isSuccess: isSuccessGenerateApiKeys, mutate: generateApiKeys } =
    useMerchantApiMutation<void, IViewDeveloperSettings>(
      "generateApiKeys"
    ).usePostMutation;

  useEffect(() => {
    if (isSuccessGenerateApiKeys) {
      refreshApiKeys();
    }
  }, [isSuccessGenerateApiKeys]);

  const { isSuccess: isSuccessSaveDevSettings, mutate: saveDeveloperSettings } =
    useMerchantApiMutation<IEditDeveloperSettings, IViewDeveloperSettings>(
      "saveDeveloperSettings"
    ).usePutMutation;

  useEffect(() => {
    if (isSuccessSaveDevSettings) {
      refreshDeveloperSettings();
    }
  }, [isSuccessSaveDevSettings]);

  const handleApiSubmit = (data: IEditDeveloperSettings) => {
    saveDeveloperSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset, control } =
    useHookForm({
      initialFormValues,
      validationSchema: devSettingsValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    });

  const goBack = () => navigate("/settings");

  return (
    <View
      apiKeySettings={apiKeys}
      developerSettings={developerSettings}
      goBack={goBack}
      isDirty={isDirty}
      clearApiKeys={() => clearApiKeys()}
      generateApiKeys={() => generateApiKeys()}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
      control={control}
    />
  );
};
